// extracted by mini-css-extract-plugin
module.exports = {"box":"AllProducts_box__FRU-p"};